export default __webpack_public_path__ + "static/media/year-plan-img.01c8a09e.png";